import AnalyticsOrganisationItemPagingResultModelBase from '../_generated/modelBases/analytics-organisation-item-paging-result-model-base';

export default class AnalyticsOrganisationItemPagingResultModel extends AnalyticsOrganisationItemPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
